// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/components/Layout/Layout.css */

.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: var(--color-cream-bg);
}

/* ---- Header ---- */
.layout__header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--color-wood-header);
  height: var(--header-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--space-md);
  box-shadow: 0 2px 8px rgba(92, 58, 30, 0.3);
}

.layout__header-title {
  color: var(--color-text-on-wood);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.layout__header-icon {
  font-size: var(--font-size-xl);
}

.layout__header-actions {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

/* ---- Main Content ---- */
.layout__main {
  flex: 1 1;
  padding: var(--space-md);
  padding-bottom: calc(var(--bottom-nav-height) + var(--space-lg));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* ---- Bottom Navigation ---- */
.layout__bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: var(--color-card-white);
  border-top: 1px solid var(--color-border);
  height: var(--bottom-nav-height);
  display: flex;
  align-items: stretch;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
}

@media (min-width: 481px) {
  .layout__bottom-nav {
    max-width: var(--max-content-width);
    left: 50%;
    transform: translateX(-50%);
  }
}

.layout__nav-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: var(--space-xs) 0;
  color: var(--color-text-light);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  transition: color var(--transition-fast);
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
}

.layout__nav-item--active {
  color: var(--color-wood-medium);
}

.layout__nav-item--active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 25%;
  right: 25%;
  height: 3px;
  background-color: var(--color-wood-medium);
  border-radius: 0 0 var(--radius-sm) var(--radius-sm);
}

.layout__nav-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.layout__nav-icon svg {
  width: 22px;
  height: 22px;
  fill: currentColor;
}

.layout__nav-label {
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.css"],"names":[],"mappings":"AAAA,0FAA0F;;AAE1F;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,SAAO;EACP,wBAAwB;EACxB,gEAAgE;EAChE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,yCAAyC;EACzC,yCAAyC;EACzC,gCAAgC;EAChC,aAAa;EACb,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE;IACE,mCAAmC;IACnC,SAAS;IACT,2BAA2B;EAC7B;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,wCAAwC;EACxC,wCAAwC;EACxC,qBAAqB;EACrB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/components/Layout/Layout.css */\n\n.layout {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  min-height: 100dvh;\n  background-color: var(--color-cream-bg);\n}\n\n/* ---- Header ---- */\n.layout__header {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: var(--color-wood-header);\n  height: var(--header-height);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--space-md);\n  box-shadow: 0 2px 8px rgba(92, 58, 30, 0.3);\n}\n\n.layout__header-title {\n  color: var(--color-text-on-wood);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  letter-spacing: 0.5px;\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.layout__header-icon {\n  font-size: var(--font-size-xl);\n}\n\n.layout__header-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n/* ---- Main Content ---- */\n.layout__main {\n  flex: 1;\n  padding: var(--space-md);\n  padding-bottom: calc(var(--bottom-nav-height) + var(--space-lg));\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* ---- Bottom Navigation ---- */\n.layout__bottom-nav {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  background-color: var(--color-card-white);\n  border-top: 1px solid var(--color-border);\n  height: var(--bottom-nav-height);\n  display: flex;\n  align-items: stretch;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);\n}\n\n@media (min-width: 481px) {\n  .layout__bottom-nav {\n    max-width: var(--max-content-width);\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}\n\n.layout__nav-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  padding: var(--space-xs) 0;\n  color: var(--color-text-light);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  transition: color var(--transition-fast);\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n  position: relative;\n}\n\n.layout__nav-item--active {\n  color: var(--color-wood-medium);\n}\n\n.layout__nav-item--active::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 25%;\n  right: 25%;\n  height: 3px;\n  background-color: var(--color-wood-medium);\n  border-radius: 0 0 var(--radius-sm) var(--radius-sm);\n}\n\n.layout__nav-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.layout__nav-icon svg {\n  width: 22px;\n  height: 22px;\n  fill: currentColor;\n}\n\n.layout__nav-label {\n  line-height: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
